<script>
import battery0 from '@assets/images/battery-icon/battery-0-percent.svg'
import battery20 from '@assets/images/battery-icon/battery-20-percent.svg'
import battery50 from '@assets/images/battery-icon/battery-50-percent.svg'
import battery75 from '@assets/images/battery-icon/battery-75-percent.svg'
import battery100 from '@assets/images/battery-icon/battery-100-percent.svg'

export default {
  name: 'OilLevelIcon',
  components: {
    battery0,
    battery20,
    battery50,
    battery75,
    battery100,
  },
  props: {
    level: {
      type: [Number, String],
      default: '',
    },
  },
  computed: {
    name() {
      if (+this.level <= 20 && +this.level >= 0) {
        return 'battery0'
      }
      if (+this.level <= 40 && +this.level > 20) {
        return 'battery20'
      }
      if (+this.level <= 60 && +this.level > 40) {
        return 'battery50'
      }
      if (+this.level <= 80 && +this.level > 60) {
        return 'battery75'
      }
      if (+this.level <= 100 && +this.level > 80) {
        return 'battery100'
      }
    },
  },
}
</script>
<template>
  <div class="batteryLevelBox">
    <div
      v-tooltip="'' + level + '%'"
      v-if="level"
      class="batteryIcon">
      <component
        :is="name"
      />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.batteryIcon > * {
  width: 40px;
  height: auto;
}

.batteryLevelBox {
  text-align: left;
}
</style>
